<template>
  <div class="page-wrapper" id="page-wrapper" style="overflow-y: scroll;">
    <v-container>
      <v-row>
        <v-col>
          <v-btn v-on:click="logOutDialog=true" block outlined>
            <v-icon>fas fa-sign-out-alt</v-icon>
            <span class="ml-1">Logout</span>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-card :loading="!account" outlined>
            <template v-if="merchant">
            <v-card-title>MERCHANT</v-card-title>
            <v-card-text>
              <v-row>
                <v-col class="py-0">
                  <b>NAME</b><br>{{merchant.title}}<br><br>
                  <b>ADDRESS</b><br>{{merchant.address}}<br><br>
                  <b>CONTACT</b><br>+44 {{merchant.contact}}<br><br>
                  <b>BALANCE</b><br>£ {{(merchant.accountBalance/100).toFixed(2)}}<br><br>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="my-0 mx-4"/>
            </template>
            <v-card-title>ACCOUNT</v-card-title>
            <v-card-text v-if="account">
              <v-row>
                <v-col class="py-0">
                  <b>NAME</b><br>{{account.name}}<br><br>
                  <b>EMAIL</b><br>{{account.email}}<br><br>
                  <b>Role</b><br/>{{account.role}} {{account.type}}<br><br>
                  <v-btn v-on:click="enableDialog" block outlined>
                    <span class="ml-1">Change Password</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              Device Preference
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col class="py-0">
                  Ask confirmation when changing page
                  <br/>
                  <button class="btn"
                          v-bind:class="{'btn-primary' : settingAskConfirmationOnChangePage === 'true'}"
                          @click="changeSetting('settingAskConfirmationOnChangePage', 'true')"
                  >Yes</button>
                  <button class="btn"
                          v-bind:class="{'btn-dark' : settingAskConfirmationOnChangePage === 'false'}"
                          @click="changeSetting('settingAskConfirmationOnChangePage', 'false')">No</button>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title>
              APP Info
            </v-card-title>
            <v-card-text>Version: {{webAppVersion}}</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="pwDialog">
      <v-card class="mx-auto">
        <v-card-title>Change Password</v-card-title>
        <v-card-text>
          <v-text-field type="password" label="PASSWORD" v-model="password" :rules="[required]"/>
          <v-text-field type="password" label="CONFIRM" v-model="confirm" :rules="[required, checkMatch]"/>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="pwDialog=false">
            CANCEL
          </v-btn>
          <v-spacer/>
          <v-btn text @click="setChangedPassword()">
            SAVE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="logOutDialog">
      <v-card>
        <v-card-title class="headline">
          Logout?
        </v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="green darken-1" text @click="logOutDialog = false">NO</v-btn>
          <v-btn color="green darken-1" text @click="logout">YES</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
    import Router from "../router";
    import {getMyMerchant, getUserByToken, setChangedPassword} from "../api/user";
    import EventBus from "../api/event-bus";
    import {getWeAppVersion} from "../api/utils";

    export default {
      name: "Setting",
      data() {
        return {
          merchant: null,
          pwDialog: false,
          logOutDialog: false,
          account: null,
          orders:[],

          password: "",
          confirm: "",
          required: value => !!value || 'Required.',
          webAppVersion:getWeAppVersion(),
          settingAskConfirmationOnChangePage:'false',
        }
      },
      created() {
        if(localStorage.getItem("settingAskConfirmationOnChangePage") === null) {
          localStorage.setItem("settingAskConfirmationOnChangePage", "false");
        }

        this.$data.settingAskConfirmationOnChangePage = localStorage.getItem("settingAskConfirmationOnChangePage");
      },
      mounted() {
        // this.getMerchantItem()
        this.getAccountInfo();
        document.getElementById("page-wrapper").scrollTop = 0;
      },
      computed: {
        checkMatch(){
          if(this.password === "" || this.confirm === "")
            return false

          if(this.password !== this.confirm)
            return 'Passwords do not match'

          return true
        }
      },
      methods: {
        logout: function() {
          this.logOutDialog = false
          if(this.$data.merchant !== null && this.$data.merchant !== false) {
            console.log("Unsubscribe from " + this.$data.merchant.id);
            unsubscribeFCMTopic("merchant-" + this.$data.merchant.id);
          }
          auth.logOut()

          Router.push('/');
        },
        enableDialog(){
          this.pwDialog = true
        },
        changeSetting: function(key, val) {
          this.$data[key] = val;
          localStorage.setItem(key, val);
        },
        getAccountInfo: function(){
          let vm = this
          getUserByToken().then(data => {
            vm.account = data
            if(vm.account.type === 'ROLE_MERCHANT') {
              vm.getMerchantItem();
            }
            // console.log("AUTH logged on from constructor");
            // EventBus.$emit("logon", res.status === 200);
          });
        },
        getMerchantItem: function() {
          let self = this;
          getMyMerchant()
            .then(function(data) {
              if(data.success) {
                self.merchant = data.item;
              }
            });
        },
        setChangedPassword: function () {
          let self = this
          setChangedPassword(this.password)
            .then(ret => {
              self.pwDialog = false
              self.logout()
            })
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Setting.vue